import Image from 'next/image';
import { cn } from '@/lib/utils';

export enum IconName {
  Cancel = 'cancel',
  Contact = 'contact',
  Dashboard = 'dashboard',
  Feedback = 'feedback',
  Language = 'language',
  Logout = 'logout',
  PatchCheckOff = 'patch-check-off',
  PatchCheckOn = 'patch-check-on',
  Profile = 'profile',
  Search = 'search',
  Settings = 'settings',
  Warning = 'warning',
  MyChatOff = 'my-chat-off',
  MyChatOn = 'my-chat-on',
  MyChatDenseOn = 'my-chat-dense-on',
  ArrowLeft = 'arrow-left',
  ArrowDownRight = 'arrow-down-right',
  Help = 'help',
  Pencil = 'pencil',
  Check = 'check',
  ArrowRight = 'arrow-right',
  Camera = 'camera',
  Replace = 'replace',
  Filter = 'filter',
  MenuOn = 'menu-on',
  MenuOff = 'menu-off',
  Network = 'network',
  Community = 'community',
  Submit = 'submit',
  X = 'x',
  Image = 'image',
  Paperclip = 'paperclip',
  Smile = 'smile',
  Video = 'video',
  Archive = 'archive',
  CheckInCircle = 'check-in-circle',
  Book = 'book',
  MoreVertical = 'more-vertical',
  Circle = 'circle',
  Plus = 'plus',
  Eye = 'eye',
  Sun = 'sun',
  Moon = 'moon',
  Sunrise = 'sunrise',
  CheckboxOn = 'checkbox-on',
  Lock = 'lock',
  AlertTriangle = 'alert-triangle',
  Copy = 'copy',
  Trash = 'trash',
  PlusCircle = 'plus-circle',
  Globe = 'globe',
  File = 'file',
  Briefcase = 'briefcase',
  MapPin = 'map-pin',
  Notification = 'notification',
  Play = 'play',
  Flag = 'flag',
}
const IconsWithManyColors = [
  IconName.PatchCheckOn,
  IconName.MyChatOn,
  IconName.MyChatDenseOn,
  IconName.MenuOn,
];

type IconProps = {
  variant: IconName;
  width?: number;
  height?: number;
  color?: string;
  className?: string;
  isWithManyColors?: boolean;
} & Omit<
  React.ComponentProps<typeof Image>,
  'src' | 'alt' | 'width' | 'height'
>;

export default function Icon({
  variant,
  width = 18,
  height = 18,
  isWithManyColors = IconsWithManyColors.includes(variant),
  className,
  ...props
}: IconProps) {
  return (
    <>
      <div
        className={cn('aspect-square bg-black', {
          hidden: isWithManyColors,
          [className ?? '']: !isWithManyColors,
        })}
        style={{
          maskImage: `url(/icons/${variant}.svg)`,
          WebkitMaskImage: `url(/icons/${variant}.svg)`,
          maskSize: 'contain',
          WebkitMaskSize: 'contain',
          maskRepeat: 'no-repeat',
          WebkitMaskRepeat: 'no-repeat',
          width,
          height,
        }}
        {...props}
        data-is-icon={true}
      />
      <Image
        src={`/icons/${variant}.svg`}
        alt={variant}
        width={width}
        height={height}
        data-is-icon={true}
        className={cn('aspect-square', {
          hidden: !isWithManyColors,
          [className ?? '']: isWithManyColors,
        })}
        {...props}
      />
    </>
  );
}
